import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import ViewAgentExpense from './ViewAgentExpense';
import EditAgentExpenses from '../EditExpenses';
import OneTimeExpenses from './oneTimeExpenses';
import RecurringExpenses from './recurringExpenses';

function ViewAgentExpenses(props) {
  const {
    agent,
    id,
    setKey,
    handleAgentUpdateClick,
  } = props;

  const [selectedExpense, setSelectedExpense] = useState(null);

  const [viewOpened, { open: openView, close: closeView }] = useDisclosure(false);
  const [editOpened, { open: openEdit, close: closeEdit }] = useDisclosure(false);

  const handleUpdate = async (data) => {
    const updatedExpense = data.expense;
    // eslint-disable-next-line max-len
    const updatedExpenses = agent?.expenses.map((expense) => (expense._id === selectedExpense._id ? updatedExpense : expense));
    return handleAgentUpdateClick({ expenses: updatedExpenses });
  };

  return (
    <>
      <OneTimeExpenses
        agent={agent}
        id={id}
        setSelectedExpense={setSelectedExpense}
        openView={openView}
        openEdit={openEdit}
      />

      <RecurringExpenses
        agent={agent}
        id={id}
        setSelectedExpense={setSelectedExpense}
        openView={openView}
        openEdit={openEdit}
      />

      <ViewAgentExpense
        open={openView}
        close={closeView}
        opened={viewOpened}
        expense={selectedExpense}
      />

      <EditAgentExpenses
        open={openEdit}
        close={closeEdit}
        opened={editOpened}
        expense={selectedExpense}
        setKey={setKey}
        id={id}
        handleAgentUpdateClick={handleUpdate}
      />
    </>
  );
}

ViewAgentExpenses.propTypes = {
  agent: PropTypes.object,
  id: PropTypes.string,
  setKey: PropTypes.func,
  handleAgentUpdateClick: PropTypes.func,
};

export default ViewAgentExpenses;
